import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CeButtonComponent, CeInputImports } from '@kempower-nx-workspace/shared/kp-design-system';

@Component({
    selector: 'lib-charger-lookup-landing',
    imports: [CommonModule, ReactiveFormsModule, CeInputImports, CeButtonComponent],
    templateUrl: './charger-lookup-landing.component.html',
    styleUrl: './charger-lookup-landing.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChargerLookupLandingComponent {
    readonly #fb = inject(FormBuilder);
    readonly #router = inject(Router);

    readonly chargerIdControl: FormControl<string | null> = this.#fb.control('', [
        Validators.required,
        Validators.minLength(3),
    ]);

    readonly form: FormGroup<{ chargerId: FormControl<string | null> }> = this.#fb.group({
        chargerId: this.chargerIdControl,
    });

    onSubmit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }
        const id = this.chargerIdControl.value?.trim();
        if (!id) {
            return;
        }
        this.#router.navigate(['/logs/result', id]);
    }
}
